import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import type {
  ExtendedApiResponse,
  SupportedCoinsRequest,
  SupportedTokens,
  SupportedTokensResponse,
} from '@coin-depo-types';

import { StorageService } from '@coin-depo-core/storage';
import { AUTH_SERVICE_TOKEN, AuthFacade } from '@coin-depo-core/auth';

import { TOKEN_API } from './token-api.token';
import { TokenApi } from './token-api.interface';
import { TokenBaseService } from './token.base.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService extends TokenBaseService {
  protected storageKey = 'supportedTokens';

  protected supportedTokens$: BehaviorSubject<SupportedTokens[]>;

  constructor(
    @Inject(TOKEN_API) private tokensApi: TokenApi,
    @Inject(AUTH_SERVICE_TOKEN) private auth: AuthFacade,
    protected storage: StorageService
  ) {
    super();

    this.supportedTokens$ = new BehaviorSubject<SupportedTokens[]>(
    this.storage.get(this.storageKey, [])
  );
  }

  override updateSupportedTokens(): Observable<
    ExtendedApiResponse<SupportedTokensResponse>
  > {
    const data: SupportedCoinsRequest = {
      client_token: this.auth.accessToken,
      username: this.auth.userData.email!,
    };

    return this.tokensApi.getSupportedTokens(data).pipe(
      tap((res) => {
        this.supportedTokens$.next(res.coin_list ?? []);
        this.storage.set(this.storageKey, res.coin_list ?? []);
      })
    );
  }
}